import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";

const UserDetailsForm = ({ initialValues, onSubmit }) => {
  return (
    <>
      <div className="container">
        <Formik
          initialValues={{
            fullName: initialValues?.fullName || "",
            area: initialValues?.area || "",
            houseNumber: initialValues?.houseNumber || "",
            pinCode: initialValues?.pinCode || "",
            city: initialValues?.city || "",
            email: initialValues?.email || "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.fullName) {
              errors.fullName = "Required";
            }
            if (!values.area) {
              errors.area = "Required";
            }
            if (!values.pinCode) {
              errors.pinCode = "Required";
            }
            if (!values.city) {
              errors.city = "Required";
            }
            if (!values.email) {
              errors.email = "Required";
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = "Invalid email address";
            }
            return errors;
          }}
          onSubmit={(values) => {
            console.log(values);
            onSubmit(values);
          }}
        >
          <div className="flex flex-col justify-start items-center bg-white shadow-md w-full">
            <div className="flex justify-between items-center p-3 border-b w-full heading">
              <h3 className="font-primaryFont font-semibold text-lg uppercase tracking-wider">
                Selected Products
              </h3>
            </div>

            <div className="cart-item-container overflow-y-scroll">
              <Form className="space-y-2 p-4 font-primaryFont container">
                <h1 className="py-2 font-secondaryFont font-semibold text-2xl underline underline-offset-[4px]">
                  Enter Your Billing Address Information
                </h1>
                <div>
                  <label htmlFor="fullName" className="block mb-1 text-sm">
                    Full Name*
                  </label>
                  <Field
                    type="text"
                    placeholder="Enter your full name"
                    id="fullName"
                    name="fullName"
                    className="focus:shadow-sm focus:shadow-blue-500 px-4 py-2 border focus:border-blue-500 rounded-lg w-full focus:outline-none"
                  />
                  <ErrorMessage
                    name="fullName"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="area" className="block mb-1 text-sm">
                    Area / Building Name*
                  </label>
                  <Field
                    type="text"
                    placeholder="Enter your full name"
                    id="area"
                    name="area"
                    className="focus:shadow-sm focus:shadow-blue-500 px-4 py-2 border focus:border-blue-500 rounded-lg w-full focus:outline-none"
                  />
                  <ErrorMessage
                    name="area"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="houseNumber" className="block mb-1 text-sm">
                    House/Flat/Block number (Optional)
                  </label>
                  <Field
                    type="text"
                    placeholder="Enter your Address"
                    id="houseNumber"
                    name="houseNumber"
                    className="focus:shadow-sm focus:shadow-blue-500 px-4 py-2 border focus:border-blue-500 rounded-lg w-full focus:outline-none"
                  />
                </div>
                <div>
                  <label htmlFor="pinCode" className="block mb-1 text-sm">
                    Pin code*
                  </label>
                  <Field
                    type="text"
                    placeholder="Enter your City Pincode"
                    id="pinCode"
                    name="pinCode"
                    className="focus:shadow-sm focus:shadow-blue-500 px-4 py-2 border focus:border-blue-500 rounded-lg w-full focus:outline-none"
                  />
                  <ErrorMessage
                    name="pinCode"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="city" className="block mb-1 text-sm">
                    City*
                  </label>
                  <Field
                    type="text"
                    placeholder="Enter your City Name"
                    id="city"
                    name="city"
                    className="focus:shadow-sm focus:shadow-blue-500 px-4 py-2 border focus:border-blue-500 rounded-lg w-full focus:outline-none"
                  />
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block mb-1 text-sm">
                    Email Address*
                  </label>
                  <Field
                    type="email"
                    placeholder="Enter your Email"
                    id="email"
                    name="email"
                    className="focus:shadow-sm focus:shadow-blue-500 px-4 py-2 border focus:border-blue-500 rounded-lg w-full focus:outline-none"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <button
                  type="submit"
                  className="bg-black hover:bg-gray-500 px-4 py-2 rounded-lg w-full text-white"
                >
                  Next
                </button>
              </Form>
            </div>
          </div>
        </Formik>
      </div>
    </>
  );
};

export default UserDetailsForm;
